<ng-container *ngIf="!edit; else editing">
    <kw-fill-layer-renderer [fillClass]="gridCell.fillClass" [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
    <div class="content-layer">
        <div class="product-header">
            <div class="product-name">
                <kw-content-element-renderer contentName="Product Name" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
            </div>
            <div class="product-promo">
                <div class="product-discount">
                    <kw-content-element-renderer contentName="Discount" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                </div>
                <div class="product-release">
                    <kw-content-element-renderer contentName="Release" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                </div>
            </div>
        </div>
        <div class="product-image">
            <a href="#" class="image">
                <img class="pic-1" src="{{gridCell?.imgSrc}}">
                <img class="pic-2" src="{{gridCell?.imgSrc}}">
            </a>
            
            <ul class="element-container action-elements product-links">
                <li>
                    <a href="#">
                        <kw-content-element-renderer contentName="Add To Cart" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <kw-content-element-renderer contentName="Add To Wish List" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                    </a>
                </li>
                <li>
                    <a href="#">
                        <kw-content-element-renderer contentName="Quick View" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                    </a>
                </li>
            </ul>
        </div>
        <div class="product-content footer">
            <div class="product-price-details">
                <div class="product-list-price">
                    <kw-content-element-renderer contentName="Price" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                </div>
                <div class="product-default-price">
                    <kw-content-element-renderer contentName="Normal Price" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #editing>
    <ng-container *ngIf="gridCell.status === 'Initial Draft';else inProgress">
        <kw-fill-layer-renderer [fillClass]="gridCell.fillClass" [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
        <div class="content-layer">
            <div class="product-header">
                <div class="product-name">
                    <kw-content-element-renderer contentName="Product Name" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                </div>
                <div class="product-promo">
                    <div class="product-discount">
                        <kw-content-element-renderer contentName="Discount" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                    </div>
                    <div class="product-release">
                        <kw-content-element-renderer contentName="Release" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                    </div>
                </div>
            </div>
            <div class="product-image">
                <a href="#" class="image">
                    <img class="pic-1" src="{{gridCell?.imgSrc}}">
                    <img class="pic-2" src="{{gridCell?.imgSrc}}">
                </a>
                
                <ul class="element-container action-elements product-links">
                    <li>
                        <a href="#">
                            <kw-content-element-renderer contentName="Add To Cart" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <kw-content-element-renderer contentName="Add To Wish List" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <kw-content-element-renderer contentName="Quick View" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="product-content footer">
                <div class="product-price-details">
                    <div class="product-list-price">
                        <kw-content-element-renderer contentName="Price" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                    </div>
                    <div class="product-default-price">
                        <kw-content-element-renderer contentName="Normal Price" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                    </div>
                </div>
            </div>
        </div>        
    </ng-container>
    <ng-template #inProgress>
        <kw-edit-placeholder-renderer [gridCell]="gridCell" (createGridCellContent)="createContent($event)"></kw-edit-placeholder-renderer>
    </ng-template>    
</ng-template>